import { translate } from "@/i18n/i18n";
import { formatTime } from "@/lib/utils";
import { PrimedTrainType } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useState } from "react";

interface PrimedProps {
    train: PrimedTrainType;
    offset: number;
}

export const Primed: FC<PrimedProps> = ({ train, offset }) => {
    const [timeRemaining, setTimeRemaining] = useState<number>(0);

    const updateTime = useCallback(() => {
        const now = new Date();
        const totalTime = train.expiresAt.getTime() - train.primedAt.getTime();
        const timeElapsed = now.getTime() - train.primedAt.getTime() - offset;
        setTimeRemaining(~~((totalTime - timeElapsed) / 1000));
    }, [train, offset]);

    useEffect(() => {
        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => clearInterval(interval);
    }, [updateTime]);
    
    //div className="w-[100%] h-[100%] flex justify-center items-center text-2xl">
    return (
        <div className="w-[100%] h-[100%] px-3 flex flex-row items-center justify-between">
            <div className="z-1 w-80 flex-auto flex flex-col items-stretch justify-center gap-0">
                <div className="text-2xl">
                    <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_19b1cfbfc4a749eca6ed63ce21112215/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                    <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_032e2c9c44604e8b82e5ee1bf3cb496c/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                    <img src="https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_14e53a08453544f2bb346b3b91ea29e8/default/dark/3.0" style={{ display: "inline", position: "relative", top: "-2px", height: "2.5rem" }}/>
                    { translate("DONO_TRAIN_IS_PRIMED") }
                </div>
                <div className="text-sm">
                    { translate("DONO_TRAIN_START_CONDITION") }
                </div>
            </div>
            <div className="w-20 text-end text-3xl">
                { formatTime(Math.max(0, timeRemaining)) }
            </div>
        </div>
    );
}